import { MapTo } from '@adobe/aem-react-editable-components';
import CtaBanner, { CtaBannerProps } from './CtaBanner';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';

const RESOURCE_TYPE = 'learning-academy/components/custom/ctabanner';

const CtaBannerEmptyFn = (props: CtaBannerProps) => !props?.contentBlock;

const EditConfig = {
  emptyLabel: 'CTA Banner: Please configure the component.',
  isEmpty: CtaBannerEmptyFn,
};

export default MapTo<CtaBannerProps>(RESOURCE_TYPE)(...WithEmptyPlaceholder(CtaBanner, EditConfig));
